import { AlertTriangle } from "lucide-react";

export default function DataQualityWarning({ warnings }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div
      data-testid="data-quality-warning-banner"
      className="border border-amber-500/30 bg-amber-500/10 px-3 py-2 flex items-start gap-2 mono text-[11px] text-amber-200"
    >
      <AlertTriangle className="h-4 w-4 mt-0.5 text-amber-400 shrink-0" />
      <div className="flex-1 space-y-0.5">
        <div className="uppercase tracking-widest text-amber-400 text-[10px] font-semibold">
          Data Quality Warning
        </div>
        {warnings.map((w, i) => (
          <div key={i} className="text-amber-200/90">{w}</div>
        ))}
      </div>
    </div>
  );
}
